import { mapState } from 'vuex';
import { apiCallers } from '../../api/apiRequest';

export default {
  name: 'index_spv',

  data: () => ({
    product_variant_: {},
    product_variants: [
      {
        id: 'trend',
        label: 'TrendPortfolio Index'
      },
      {
        id: 'trend-old',
        label: 'TrendPortfolio Index-OLD'
      },
      {
        id: 'deka',
        label: 'Deka-MultiAktiv Global'
      },
      {
        id: 'deka-old',
        label: 'Deka-MultiAktiv Global-OLD'
      },
      {
        id: 'climate',
        label: 'Climate Objective Index'
      },
      {
        id: 'climate-old',
        label: 'Climate Objective Index-OLD'
      },
      {
        id: 'euro',
        label: 'EURO STOXX 50<sup>®<sup>'
      },
      {
        id: 'vola',
        label: 'VolaIndexPerform'
      }
    ],

    show_style: false
  }),

  computed: {
    ...mapState([
      'appConfigs'
    ]),

    config () {
      return this.appConfigs[this.$options.configIndex] || {};
    },

    apiRequest () {
      return apiCallers[this.config.app];
    },
  },

  created() {
    this.product_variant_ = this.product_variants[0];

    const queries = window.location.href.split('?');

    if (queries && queries.length) {
      queries
        .map(query => {
          if (query === 'show_style=true') {
            this.show_style = true;
          }
        });
    }
  }
};



// WEBPACK FOOTER //
// ./src/apps/index/logic.js